import { TABLES } from "../db";
import { BaseLocalRepository } from "./BaseLocalRepository";

export class LocalTripCargoRepository extends BaseLocalRepository {
  constructor(db) {
    super(db, TABLES.TRIP_CARGO);
  }

  async listByTripId(tripId) {
    return this.table.where("tripId").equals(tripId).toArray();
  }
}
